import React from 'react';
import "./style.css";
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import PatientsList from './scenes/patients-list/index';
import PatientDetails from './scenes/patient-details';

export default withRouter(class Registers extends React.Component {
    render() {
        return (
            <div className="Registers">
                <Switch>
                    <Route path="/registers/list" component={PatientsList} />
                    <Route path="/registers/details/:patient"
                        render={(props) =>
                            <PatientDetails {...props} user={this.props.user} />}/>
                    />
                    <Route render={(props) => <Redirect to="/registers/list" />} />
                </Switch>
            </div>
        );
    }
})


// WEBPACK FOOTER //
// ./src/scenes/main-page/scenes/registers/index.js